// Product Sales Dashboard (the embedded Superset unit-sales board) — the screen's strings in the portal's four
// languages (2026-10-21).
const en = {
  loading: 'Loading...',
  notAuthorized: 'You are not authorized to view this page.',
};
const ko = {
  loading: '불러오는 중...',
  notAuthorized: '이 페이지를 볼 권한이 없습니다.',
};
const vi = {
  loading: 'Đang tải...',
  notAuthorized: 'Bạn không có quyền xem trang này.',
};
const zh = {
  loading: '加载中...',
  notAuthorized: '您无权查看此页面。',
};

// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "loading": "Chargement...",
  "notAuthorized": "Vous n'êtes pas autorisé à consulter cette page."
};
const ja = {
  "loading": "読み込み中...",
  "notAuthorized": "このページを表示する権限がありません。"
};

const dictionary = { ns: 'xUnitSales', en, ko, vi, zh, fr, ja };

export default dictionary;
